export const GET_STORE_CUSTOMER_GROUPS_START = 'GET_STORE_CUSTOMER_GROUPS_START';
export const GET_STORE_CUSTOMER_GROUPS_SUCCESS = 'GET_STORE_CUSTOMER_GROUPS_SUCCESS';
export const GET_STORE_CUSTOMER_GROUPS_FAILED = 'GET_STORE_CUSTOMER_GROUPS_FAILED';

export const GET_STORE_CUSTOMER_DEFAULT_GROUP_START = 'GET_STORE_CUSTOMER_DEFAULT_GROUP_START';
export const GET_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS = 'GET_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS';
export const GET_STORE_CUSTOMER_DEFAULT_GROUP_FAILED = 'GET_STORE_CUSTOMER_DEFAULT_GROUP_FAILED';

export const EDIT_STORE_CUSTOMER_DEFAULT_GROUP_START = 'EDIT_STORE_CUSTOMER_DEFAULT_GROUP_START';
export const EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS = 'EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS';
export const EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED = 'EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED';

export const GET_STORE_CUSTOMERS_GRID_START = 'GET_STORE_CUSTOMERS_GRID_START';
export const GET_STORE_CUSTOMERS_GRID_SUCCESS = 'GET_STORE_CUSTOMERS_GRID_SUCCESS';
export const GET_STORE_CUSTOMERS_GRID_FAILED = 'GET_STORE_CUSTOMERS_GRID_FAILED';

export const GET_STORE_CUSTOMER_DATA_START = 'GET_STORE_CUSTOMER_DATA_START';
export const GET_STORE_CUSTOMER_DATA_SUCCESS = 'GET_STORE_CUSTOMER_DATA_SUCCESS';
export const GET_STORE_CUSTOMER_DATA_FAILED = 'GET_STORE_CUSTOMER_DATA_FAILED';

export const DELETE_CUSTOMER_ACCOUNT_START = 'DELETE_CUSTOMER_ACCOUNT_START';
export const DELETE_CUSTOMER_ACCOUNT_SUCCESS = 'DELETE_CUSTOMER_ACCOUNT_SUCCESS';
export const DELETE_CUSTOMER_ACCOUNT_FAILED = 'DELETE_CUSTOMER_ACCOUNT_FAILED';

export const LOGIN_AS_CUSTOMER_START = 'LOGIN_AS_CUSTOMER_START';
export const LOGIN_AS_CUSTOMER_SUCCESS = 'LOGIN_AS_CUSTOMER_SUCCESS';
export const LOGIN_AS_CUSTOMER_FAILED = 'LOGIN_AS_CUSTOMER_FAILED';

export const RESET_CUSTOMER_PASSWORD_START = 'RESET_CUSTOMER_PASSWORD_START';
export const RESET_CUSTOMER_PASSWORD_SUCCESS = 'RESET_CUSTOMER_PASSWORD_SUCCESS';
export const RESET_CUSTOMER_PASSWORD_FAILED = 'RESET_CUSTOMER_PASSWORD_FAILED';

export const UPDATE_CUSTOMER_DATA_START = 'UPDATE_CUSTOMER_DATA_START';
export const UPDATE_CUSTOMER_DATA_SUCCESS = 'UPDATE_CUSTOMER_DATA_SUCCESS';
export const UPDATE_CUSTOMER_DATA_FAILED = 'UPDATE_CUSTOMER_DATA_FAILED';

export const CREATE_CUSTOMER_START = 'CREATE_CUSTOMER_START';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_FAILED = 'CREATE_CUSTOMER_FAILED';

export const GET_CUSTOMER_REWARDS_START = 'GET_CUSTOMER_REWARDS_START';
export const GET_CUSTOMER_REWARDS_SUCCESS = 'GET_CUSTOMER_REWARDS_SUCCESS';
export const GET_CUSTOMER_REWARDS_FAILED = 'GET_CUSTOMER_REWARDS_FAILED';

export const GET_CUSTOMER_REWARDS_BALANCE_START = 'GET_CUSTOMER_REWARDS_BALANCE_START';
export const GET_CUSTOMER_REWARDS_BALANCE_SUCCESS = 'GET_CUSTOMER_REWARDS_BALANCE_SUCCESS';
export const GET_CUSTOMER_REWARDS_BALANCE_FAILED = 'GET_CUSTOMER_REWARDS_BALANCE_FAILED';

export const UPDATE_CUSTOMER_REWARDS_BALANCE_START = 'UPDATE_CUSTOMER_REWARDS_BALANCE_START';
export const UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS = 'UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS';
export const UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED = 'UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED';

export const GET_CUSTOMER_GIFTCARD_TRANSACTIONS_START = 'GET_CUSTOMER_GIFTCARD_TRANSACTIONS_START';
export const GET_CUSTOMER_GIFTCARD_TRANSACTIONS_SUCCESS = 'GET_CUSTOMER_GIFTCARD_TRANSACTIONS_SUCCESS';
export const GET_CUSTOMER_GIFTCARD_TRANSACTIONS_FAILED = 'GET_CUSTOMER_GIFTCARD_TRANSACTIONS_FAILED';

export const GET_CUSTOMER_GIFTCARDS_BALANCE_START = 'GET_CUSTOMER_GIFTCARDS_BALANCE_START';
export const GET_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS = 'GET_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS';
export const GET_CUSTOMER_GIFTCARDS_BALANCE_FAILED = 'GET_CUSTOMER_GIFTCARDS_BALANCE_FAILED';

export const UPDATE_CUSTOMER_GIFTCARDS_BALANCE_START = 'UPDATE_CUSTOMER_GIFTCARDS_BALANCE_START';
export const UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS = 'UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS';
export const UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED = 'UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED';

export const GET_CUSTOMERS_ACCESS_LIST_START = 'GET_CUSTOMERS_ACCESS_LIST_START';
export const GET_CUSTOMERS_ACCESS_LIST_SUCCESS = 'GET_CUSTOMERS_ACCESS_LIST_SUCCESS';
export const GET_CUSTOMERS_ACCESS_LIST_FAILED = 'GET_CUSTOMERS_ACCESS_LIST_FAILED';

export const UPDATE_CUSTOMERS_ACCESS_START = 'UPDATE_CUSTOMERS_ACCESS_START';
export const UPDATE_CUSTOMERS_ACCESS_SUCCESS = 'UPDATE_CUSTOMERS_ACCESS_SUCCESS';
export const UPDATE_CUSTOMERS_ACCESS_FAILED = 'UPDATE_CUSTOMERS_ACCESS_FAILED';

export const GET_STORE_CUSTOMER_CARD_DATA_START = 'GET_STORE_CUSTOMER_CARD_DATA_START';
export const GET_STORE_CUSTOMER_CARD_DATA_SUCCESS = 'GET_STORE_CUSTOMER_CARD_DATA_SUCCESS';
export const GET_STORE_CUSTOMER_CARD_DATA_FAILED = 'GET_STORE_CUSTOMER_CARD_DATA_FAILED';

export const GET_CUSTOMER_ACTIVE_CREDIT_CARDS_START = 'GET_CUSTOMER_ACTIVE_CREDIT_CARDS_START';
export const GET_CUSTOMER_ACTIVE_CREDIT_CARDS_SUCCESS = 'GET_CUSTOMER_ACTIVE_CREDIT_CARDS_SUCCESS';
export const GET_CUSTOMER_ACTIVE_CREDIT_CARDS_FAILED = 'GET_CUSTOMER_ACTIVE_CREDIT_CARDS_FAILED';

export const GET_CUSTOMER_SUBSCRIPTIONS_START = 'GET_CUSTOMER_SUBSCRIPTIONS_START';
export const GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTIONS_FAILED = 'GET_CUSTOMER_SUBSCRIPTIONS_FAILED';

export const ADD_IMPORT_CUSTOMERS_TO_QUEUE_START = 'ADD_IMPORT_CUSTOMERS_TO_QUEUE_START';
export const ADD_IMPORT_CUSTOMERS_TO_QUEUE_SUCCESS = 'ADD_IMPORT_CUSTOMERS_TO_QUEUE_SUCCESS';
export const ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED = 'ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED';

export const RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE = 'RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE';

export const GET_IMPORT_CUSTOMERS_QUEUE_TASKS_START = 'GET_IMPORT_CUSTOMERS_QUEUE_TASKS_START';
export const GET_IMPORT_CUSTOMERS_QUEUE_TASKS_SUCCESS = 'GET_IMPORT_CUSTOMERS_QUEUE_TASKS_SUCCESS';
export const GET_IMPORT_CUSTOMERS_QUEUE_TASKS_FAILED = 'GET_IMPORT_CUSTOMERS_QUEUE_TASKS_FAILED';

export const DELETE_IMPORT_CUSTOMER_QUEUE_TASK_START = 'DELETE_IMPORT_CUSTOMER_QUEUE_TASK_START';
export const DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS = 'DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS';
export const DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED = 'DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED';

export const GET_EXISTING_CUSTOMERS_BY_EMAILS_START = 'GET_EXISTING_CUSTOMERS_BY_EMAILS_START';
export const GET_EXISTING_CUSTOMERS_BY_EMAILS_SUCCESS = 'GET_EXISTING_CUSTOMERS_BY_EMAILS_SUCCESS';
export const GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED = 'GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED';

export const getStoreCustomerGroupsStart = () => ({
  type: GET_STORE_CUSTOMER_GROUPS_START
});

export const getStoreCustomerGroupsSuccess = (data) => ({
  type: GET_STORE_CUSTOMER_GROUPS_SUCCESS,
  data
});

export const getStoreCustomerGroupsFailed = (error) => ({
  type: GET_STORE_CUSTOMER_GROUPS_FAILED,
  error
});

export const getStoreCustomerDefaultGroupStart = () => ({
  type: GET_STORE_CUSTOMER_DEFAULT_GROUP_START
});

export const getStoreCustomerDefaultGroupSuccess = (data) => ({
  type: GET_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS,
  data
});

export const getStoreCustomerDefaultGroupFailed = (error) => ({
  type: GET_STORE_CUSTOMER_DEFAULT_GROUP_FAILED,
  error
});

export const editStoreCustomerDefaultGroupStart = () => ({
  type: EDIT_STORE_CUSTOMER_DEFAULT_GROUP_START
});

export const editStoreCustomerDefaultGroupSuccess = (data) => ({
  type: EDIT_STORE_CUSTOMER_DEFAULT_GROUP_SUCCESS,
  data
});

export const editStoreCustomerDefaultGroupFailed = (error) => ({
  type: EDIT_STORE_CUSTOMER_DEFAULT_GROUP_FAILED,
  error
});

export const getStoreCustomersGridStart = (isCSVData) => ({
  type: GET_STORE_CUSTOMERS_GRID_START,
  isCSVData
});

export const getStoreCustomersGridSuccess = (data, isCSVData) => ({
  type: GET_STORE_CUSTOMERS_GRID_SUCCESS,
  data,
  isCSVData
});

export const getStoreCustomersGridFailed = (error, isCSVData) => ({
  type: GET_STORE_CUSTOMERS_GRID_FAILED,
  error,
  isCSVData
});

export const getStoreCustomerDataStart = () => ({
  type: GET_STORE_CUSTOMER_DATA_START
});

export const getStoreCustomerDataSuccess = (data) => ({
  type: GET_STORE_CUSTOMER_DATA_SUCCESS,
  data
});

export const getStoreCustomerDataFailed = (error) => ({
  type: GET_STORE_CUSTOMER_DATA_FAILED,
  error
});

export const deleteCustomerAccountStart = () => ({
  type: DELETE_CUSTOMER_ACCOUNT_START
});

export const deleteCustomerAccountSuccess = (id) => ({
  type: DELETE_CUSTOMER_ACCOUNT_SUCCESS,
  id
});

export const deleteCustomerAccountFailed = (error) => ({
  type: DELETE_CUSTOMER_ACCOUNT_FAILED,
  error
});

export const loginAsCustomerStart = () => ({
  type: LOGIN_AS_CUSTOMER_START
});

export const loginAsCustomerSuccess = (url) => ({
  type: LOGIN_AS_CUSTOMER_SUCCESS,
  url
});

export const loginAsCustomerFailed = (error) => ({
  type: LOGIN_AS_CUSTOMER_FAILED,
  error
});

export const resetCustomerPasswordStart = () => ({
  type: RESET_CUSTOMER_PASSWORD_START
});

export const resetCustomerPasswordSuccess = () => ({
  type: RESET_CUSTOMER_PASSWORD_SUCCESS
});

export const resetCustomerPasswordFailed = (error) => ({
  type: RESET_CUSTOMER_PASSWORD_FAILED,
  error
});

export const updateCustomerDataStart = () => ({
  type: UPDATE_CUSTOMER_DATA_START
});

export const updateCustomerDataSuccess = (data) => ({
  type: UPDATE_CUSTOMER_DATA_SUCCESS,
  data
});

export const updateCustomerDataFailed = (error) => ({
  type: UPDATE_CUSTOMER_DATA_FAILED,
  error
});

export const createCustomerStart = () => ({
  type: CREATE_CUSTOMER_START
});

export const createCustomerSuccess = (data) => ({
  type: CREATE_CUSTOMER_SUCCESS,
  data
});

export const createCustomerFailed = (error) => ({
  type: CREATE_CUSTOMER_FAILED,
  error
});

export const getCustomerRewardsStart = () => ({
  type: GET_CUSTOMER_REWARDS_START
});

export const getCustomerRewardsSuccess = (data) => ({
  type: GET_CUSTOMER_REWARDS_SUCCESS,
  data
});

export const getCustomerRewardsFailed = (error) => ({
  type: GET_CUSTOMER_REWARDS_FAILED,
  error
});

export const getCustomerRewardsBalanceStart = () => ({
  type: GET_CUSTOMER_REWARDS_BALANCE_START
});

export const getCustomerRewardsBalanceSuccess = (data) => ({
  type: GET_CUSTOMER_REWARDS_BALANCE_SUCCESS,
  data
});

export const getCustomerRewardsBalanceFailed = (error) => ({
  type: GET_CUSTOMER_REWARDS_BALANCE_FAILED,
  error
});

export const updateCustomerRewardsBalanceStart = () => ({
  type: UPDATE_CUSTOMER_REWARDS_BALANCE_START
});

export const updateCustomerRewardsBalanceSuccess = (balance) => ({
  type: UPDATE_CUSTOMER_REWARDS_BALANCE_SUCCESS,
  balance
});

export const updateCustomerRewardsBalanceFailed = (error) => ({
  type: UPDATE_CUSTOMER_REWARDS_BALANCE_FAILED,
  error
});

export const getCustomerGiftCardTransactionsStart = () => ({
  type: GET_CUSTOMER_GIFTCARD_TRANSACTIONS_START
});

export const getCustomerGiftCardTransactionsSuccess = (data) => ({
  type: GET_CUSTOMER_GIFTCARD_TRANSACTIONS_SUCCESS,
  data
});

export const getCustomerGiftCardTransactionsFailed = (error) => ({
  type: GET_CUSTOMER_GIFTCARD_TRANSACTIONS_FAILED,
  error
});

export const getCustomerGiftCardsBalanceStart = () => ({
  type: GET_CUSTOMER_GIFTCARDS_BALANCE_START
});

export const getCustomerGiftCardsBalanceSuccess = (data) => ({
  type: GET_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS,
  data
});

export const getCustomerGiftCardsBalanceFailed = (error) => ({
  type: GET_CUSTOMER_GIFTCARDS_BALANCE_FAILED,
  error
});

export const updateCustomerGiftCardsBalanceStart = () => ({
  type: UPDATE_CUSTOMER_GIFTCARDS_BALANCE_START
});

export const updateCustomerGiftCardsBalanceSuccess = (balance) => ({
  type: UPDATE_CUSTOMER_GIFTCARDS_BALANCE_SUCCESS,
  balance
});

export const updateCustomerGiftCardsBalanceFailed = (error) => ({
  type: UPDATE_CUSTOMER_GIFTCARDS_BALANCE_FAILED,
  error
});

export const getCustomersAccessListStart = () => ({
  type: GET_CUSTOMERS_ACCESS_LIST_START
});

export const getCustomersAccessListSuccess = (data) => ({
  type: GET_CUSTOMERS_ACCESS_LIST_SUCCESS,
  data
});

export const getCustomersAccessListFailed = (error) => ({
  type: GET_CUSTOMERS_ACCESS_LIST_FAILED,
  error
});

export const updateCustomersAccessStart = () => ({
  type: UPDATE_CUSTOMERS_ACCESS_START
});

export const updateCustomersAccessSuccess = (updatedParamsAccess) => ({
  type: UPDATE_CUSTOMERS_ACCESS_SUCCESS,
  updatedParamsAccess
});

export const updateCustomersAccessFailed = (error) => ({
  type: UPDATE_CUSTOMERS_ACCESS_FAILED,
  error
});

export const getStoreCustomerCardDataStart = () => ({
  type: GET_STORE_CUSTOMER_CARD_DATA_START
});

export const getStoreCustomerCardDataSuccess = (data) => ({
  type: GET_STORE_CUSTOMER_CARD_DATA_SUCCESS,
  data
});

export const getStoreCustomerCardDataFailed = (error) => ({
  type: GET_STORE_CUSTOMER_CARD_DATA_FAILED,
  error
});

export const getCustomerActiveCreditCardsStart = () => ({
  type: GET_CUSTOMER_ACTIVE_CREDIT_CARDS_START
});

export const getCustomerActiveCreditCardsSuccess = (data) => ({
  type: GET_CUSTOMER_ACTIVE_CREDIT_CARDS_SUCCESS,
  data
});

export const getCustomerActiveCreditCardsFailed = (error) => ({
  type: GET_CUSTOMER_ACTIVE_CREDIT_CARDS_FAILED,
  error
});

export const getCustomerSubscriptionsStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_START
});

export const getCustomerSubscriptionsSuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS,
  data
});

export const getCustomerSubscriptionsFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_FAILED,
  error
});

export const addImportCustomersToQueueStart = () => ({
  type: ADD_IMPORT_CUSTOMERS_TO_QUEUE_START
});

export const addImportCustomersToQueueSuccess = (tasks, fileName) => ({
  type: ADD_IMPORT_CUSTOMERS_TO_QUEUE_SUCCESS,
  tasks,
  fileName
});

export const addImportCustomersToQueueFailed = (error) => ({
  type: ADD_IMPORT_CUSTOMERS_TO_QUEUE_FAILED,
  error
});

export const receiveCustomersImportQueueTaskUpdate = (data) => ({
  type: RECEIVE_CUSTOMERS_IMPORT_QUEUE_TASK_UPDATE,
  data
});

export const getCustomersImportQueueTasksStart = () => ({
  type: GET_IMPORT_CUSTOMERS_QUEUE_TASKS_START
});

export const getCustomersImportQueueTasksSuccess = (data) => ({
  type: GET_IMPORT_CUSTOMERS_QUEUE_TASKS_SUCCESS,
  data
});

export const getCustomersImportQueueTasksFailed = (error) => ({
  type: GET_IMPORT_CUSTOMERS_QUEUE_TASKS_FAILED,
  error
});

export const deleteCustomerImportQueueTaskStart = () => ({
  type: DELETE_IMPORT_CUSTOMER_QUEUE_TASK_START
});

export const deleteCustomerImportQueueTaskSuccess = (id) => ({
  type: DELETE_IMPORT_CUSTOMER_QUEUE_TASK_SUCCESS,
  id
});

export const deleteCustomerImportQueueTaskFailed = (error) => ({
  type: DELETE_IMPORT_CUSTOMER_QUEUE_TASK_FAILED,
  error
});

export const getExistingCustomersByEmailsStart = () => ({
  type: GET_EXISTING_CUSTOMERS_BY_EMAILS_START
});

export const getExistingCustomersByEmailsSuccess = () => ({
  type: GET_EXISTING_CUSTOMERS_BY_EMAILS_SUCCESS
});

export const getExistingCustomersByEmailsFailed = (error) => ({
  type: GET_EXISTING_CUSTOMERS_BY_EMAILS_FAILED,
  error
});
